const defaultValue = "detalhes";

const sideContentAttendanceSelected = (state = defaultValue, action) => {
  switch (action.type) {
    case "SELECTEC_SIDE_CONTENT_ATTENDANCE":
      return action.selected;
    default:
      return state;
  }
};

export default sideContentAttendanceSelected;
